import { useDispatch, useSelector } from "react-redux";
import { ModalBase } from "../../../../components/Modals/ModalBase"
import { State } from "../../../../reducers";
import { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { postNombreDepartamento, postNombreMunicipio } from "../../../../actions/catalogos.actions";
import { getFechaCA } from "../../../../utils/stringDate";
import { TotalesCF, TotalesCFF, TotalesComprobanteRetencion, TotalesExportacion, TotalesNotaRemision, TotalesSujeto, formatearNum } from "../VisualizacionFactura/TotalesDetalle";
import { Pagination } from "../../../../components/Pagination";
import { generateQRImageFromBits, getLogoEmpresa, getQR } from "../../../../actions/operaciones/operaciones.actions";
import { renderEstadoDoc } from "../../../../utils/estados";

const ModalViewRelacionado = (props: any) => {
  const {activeDoc} = props;
  const {DetallesDTE: {identificacion, sujetoExcluido, receptor, emisor, otrosDocumentos, cuerpoDocumento, resumen, documentoRelacionado}, detallenota} = activeDoc;

  const {datosEmisor, tipoDocumento, tipoDocumentosEmision, unidadesMedida} = useSelector((state: State) => state.catalogos);
  const datosReceptor = useSelector((state: State) => state.documentos.datosReceptor.formHistorial)

  const [qrCode, setQRCode] = useState<string>("");
  const [productos, setProductos] = useState<Array<any>>([]);
  const [docRelacionados, setDocRelacionados] = useState<Array<any>>([]);
  const [otrosDocAsociados, setOtrosDocAsociados] = useState<Array<any>>([]);
  const [direccionEmisor, setDireccionEmisor] = useState({departamento: "", municipio: ""});
  const history = useHistory();
  const dispatch = useDispatch();

  const clienteReceptor = receptor ?? sujetoExcluido;

  const notasOrdenadas = useMemo(() => {
    if (detallenota) {
      const dteOrdenados = detallenota.map((el: any) => {
        const fechaCompleta = new Date(`${el.DetallesDTE?.identificacion?.fecEmi}T${el.DetallesDTE?.identificacion?.horEmi}`);
        return { ...el, fechaCompleta };
      });
      return dteOrdenados.sort((a:any, b:any) => a.fechaCompleta - b.fechaCompleta);
    } 
    return false;
  }, [detallenota]);

  useEffect(() => {
    if (activeDoc) { 
      if (Array.isArray(cuerpoDocumento)) setProductos(cuerpoDocumento);
      else setProductos([cuerpoDocumento]);

      if (documentoRelacionado) {
        if (Array.isArray(documentoRelacionado)) setDocRelacionados(documentoRelacionado);
        else setDocRelacionados([documentoRelacionado]);
      }

      if (otrosDocumentos) {
        if (Array.isArray(otrosDocumentos)) setOtrosDocAsociados(otrosDocumentos);
        else setOtrosDocAsociados([otrosDocumentos]);
      }
      
      obtenerQR();
    } else {
      history.goBack();
    }
  }, []);

  const documentoReceptor = useMemo(() => {
    const tipoDoc = clienteReceptor?.tipoDocumento;
    const nit = clienteReceptor?.nit;

    if (!tipoDoc) {
      if (nit) {
        return {
          numDoc: nit,
          tipoDoc: tipoDocumento.find((doc) => doc.codigo === "36")?.valor
        }
      }
    } else {
      return {
        numDoc: clienteReceptor?.numDocumento,
        tipoDoc: tipoDocumento.find((doc) => doc.codigo === tipoDoc)?.valor
      }
    }
    return { numDoc: '-', tipoDoc: ''}
  }, [activeDoc])

  useEffect(() => {
    if (clienteReceptor?.direccion) {
      const {departamento, municipio} = clienteReceptor.direccion;
      if (departamento && municipio) {
        Promise.all([
          postNombreDepartamento(departamento),
          postNombreMunicipio(departamento, municipio),
        ]).then((values) => {
          setDireccionEmisor({departamento: values[0]?.body?.valor || "", municipio: values[1].body?.valor})
        })
      }
    }
  }, []);

  const [tableProductos, setTableProductos] = useState(productos)
    useEffect(() => {
        setTableProductos(productos)
    }, [productos])

  const obtenerQR = async () => {
    const qrRes = await getQR(activeDoc?.documento);
    setQRCode(`${qrRes.qr}`)
  }

  return (
    <ModalBase Styles={{maxWidth: '2000px', width: '80%', padding:"1.5%"}}>
      <div className='modal-content'>
        <div className='w-layout-hflex'>
          <h3 className='card-title l'>Documento relacionado</h3>
        </div>
        <div className='form-separator'></div>
        <div>
          <div className="liquidacion-dte-container">
            <div className="dte-title">
                <label>DOCUMENTO TRIBUTARIO ELECTRÓNICO</label>
                <label>{tipoDocumentosEmision.find((tipodoc) => tipodoc.codigodocumento === activeDoc.DetallesDTE?.identificacion?.tipoDte)?.nombre ?? ''}</label>
                {renderEstadoDoc(activeDoc)}
            </div>
            <div className="separador" />
            <div className="dte-section fx-wrap">
                <div className="dte-subsection subsection-resp" style={{ border: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <img alt="Logo" src={getLogoEmpresa()} className='logo-itprofis'/>
                </div>
                <div className="dte-subsection subsection-resp">
                    <table className="dte-table">
                        <tr>
                            <td>Documento Tributario Electrónico Versión:</td>
                            <td>{identificacion?.version}</td>
                        </tr>
                        <tr>
                            <td>Código de Generación:</td>
                            <td>{identificacion?.codigoGeneracion}</td>
                        </tr>
                        <tr>
                            <td>Número de control:</td>
                            <td>{identificacion?.numeroControl}</td>
                        </tr>
                        <tr>
                            <td>Moneda:</td>
                            <td>USD - Dólar estadounidense</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div className="dte-section fx-wrap">
                {/* DATOS DEL RECEPTOR */}
                <div className="dte-subsection subsection-resp">
                    <label className="dte-subsection-title">Receptor</label>
                    <table className="dte-table">
                        <tr><td>Nombre:</td><td>{clienteReceptor?.nombre}</td></tr>
                        <tr><td>Tipo de doc. de identificación:</td><td>{documentoReceptor.tipoDoc}</td></tr>
                        <tr><td>No. de doc. de identificación:</td><td>{documentoReceptor.numDoc}</td></tr>
                        {clienteReceptor?.nrc && (<tr><td>NRC:</td><td>{clienteReceptor?.nrc || '--'}</td></tr>)}
                        <tr><td>Actividad económica:</td><td>{clienteReceptor?.codActividad || clienteReceptor?.descActividad ? `${clienteReceptor?.codActividad ?? ''}-${clienteReceptor?.descActividad ?? ''}` : '--'}</td></tr>
                        <tr><td>Teléfono celular:</td><td>{clienteReceptor?.telefono}</td></tr>
                        <tr><td>Correo electrónico:</td><td>{clienteReceptor?.correo}</td></tr>
                        {clienteReceptor?.direccion?.complemento && (<tr><td>Dirección:</td><td>{clienteReceptor?.direccion?.complemento || '--'}</td></tr>)}
                        {direccionEmisor.departamento && (<tr><td>Departamento:</td><td>{direccionEmisor.departamento || '--'}</td></tr>)}
                        {direccionEmisor.municipio && (<tr><td>Municipio:</td><td>{direccionEmisor.municipio || '--'}</td></tr>)}
                    </table>
                </div>
                {/* DATOS DEL EMISOR */}
                <div className="dte-subsection subsection-resp">
                    <label className="dte-subsection-title">Emisor</label>
                    <table className="dte-table">
                        <tr><td>Tipo de persona:</td><td>{datosEmisor?.desTipoEmpresa}</td></tr>
                        <tr><td>Tipo de contribuyente:</td><td>{datosEmisor?.desContribuyente}</td></tr>
                        <tr><td>Nombre del cliente:</td><td>{datosEmisor?.nombre}</td></tr>
                        <tr><td>Dirección:</td><td>{datosEmisor?.complemento}</td></tr>
                        <tr><td>Departamento:</td><td>{datosEmisor?.departamentonombre}</td></tr>
                        <tr><td>Municipio:</td><td>{datosEmisor?.municipionombre}</td></tr>
                        <tr><td>Giro:</td><td>{datosEmisor?.descactividad}</td></tr>
                        <tr><td>NIT:</td><td>{datosEmisor?.nit}</td></tr>
                        <tr><td>NRC:</td><td>{datosEmisor?.nrc}</td></tr>
                        <tr><td>Teléfono celular:</td><td>{datosEmisor?.telefono}</td></tr>
                        <tr><td>Correo electrónico:</td><td>{datosEmisor?.correo}</td></tr>
                    </table>
                </div>
            </div>
            {/* DATOS DE EXPORTACION */}
            {
              (receptor?.recintoFiscalDesc || receptor?.regimenDesc) && 
              (
                <div className="dte-section">
                    <div className="dte-subsection">
                        <label className="dte-subsection-title">Datos de exportación</label>
                        <table className="dte-table">
                            <tr><td>Régimen de exportación:</td><td>{emisor?.regimen || '--'}</td></tr>
                            <tr><td>Recinto fiscal:</td><td>{receptor?.recintoFiscalDesc || '--'}</td></tr>
                            <tr><td>INCOTERMS:</td><td>{receptor?.incotermsDesc || '--'}</td></tr>
                            <tr><td>País de exportación:</td><td>{receptor?.nombrePais || '--'}</td></tr>
                        </table>
                    </div>
                </div>
              )
            }
            {/* DETALLE DE DOCUMENTOS RELACIONADOS */}
            {
              docRelacionados.length > 0 && 
              (
                <div className="dte-section">
                  <div className="dte-subsection">
                      <label className="dte-subsection-title">Documentos relacionados</label>
                      <div style={{overflowX: "scroll"}}>
                        <table className="table-main-responsive responsive-table-main td-left table-pointer" style={{marginTop: '8px'}}>
                          <thead>
                              <tr>
                                  <td>Tipo de documento</td>
                                  <td>Número de documento</td>
                                  <td>Código de generación</td>
                                  <td>Fecha de emisión</td>
                              </tr>
                          </thead>
                          <tbody>
                          {
                            docRelacionados.map((doc) => (
                              <tr>
                                <td>{tipoDocumentosEmision.find((tipoDoc) => tipoDoc.codigodocumento === doc.tipoDocumento)?.nombre ?? doc.tipoDocumento}</td>
                                <td>{doc.DTERelacionado ?? '--'}</td>
                                <td>{doc.numeroDocumento}</td>
                                <td>{getFechaCA(doc.fechaEmision)}</td>
                              </tr>
                            ))
                          }
                          </tbody>
                        </table>
                      </div>
                  </div>
                </div>
              )
            }
            {/* DETALLE DE OTROS DOCUMENTOS ASOCIADOS */}
            {
              otrosDocAsociados.length > 0 && 
              (
                <div className="dte-section">
                  <div className="dte-subsection">
                      <label className="dte-subsection-title">Otros documentos asociados</label>
                      <div style={{overflowX: "scroll"}}>
                        <table className="table-main-responsive responsive-table-main td-left table-pointer" style={{marginTop: '8px'}}>
                            <thead>
                                <tr>
                                    <td>Código de documento</td>
                                    <td>Descripción</td>
                                    <td>Detalle del documento</td>
                                </tr>
                            </thead>
                            <tbody>
                            {
                              otrosDocAsociados.map((doc) => (
                                <tr>
                                  <td>{doc.descCodDocAsociado ?? '--'}</td>
                                  <td>{doc.descDocumento ?? '--'}</td>
                                  <td>{doc.detalleDocumento ?? '--'}</td>
                                </tr>
                              ))
                            }
                            </tbody>
                        </table>
                      </div>
                  </div>
                </div>
              )
            }
            {/* DETALLE DE NOTAS O DOCUMENTOS QUE AJUSTARON */}
            {
              notasOrdenadas && 
              (
                <div className="dte-section">
                  <div className="dte-subsection">
                      <label className="dte-subsection-title">Documentos de ajuste</label>
                      <div style={{overflowX: "scroll"}}>
                        <table className="table-main-responsive responsive-table-main td-left table-pointer" style={{marginTop: '8px'}}>
                            <thead>
                                <tr>
                                    <td>Tipo de documento</td>
                                    <td>Número de control</td>
                                    <td>Código de generación</td>
                                    <td>Fecha de emisión</td>
                                    <td>Total</td>
                                    <td>Estado</td>
                                </tr>
                            </thead>
                            <tbody>
                            {
                              notasOrdenadas.map((doc: any) => (
                                <tr>
                                  <td>{tipoDocumentosEmision.find((tipoDoc) => tipoDoc.iddocumento === parseInt(doc.tipo_dte))?.nombre ?? doc.tipo_dte}</td>
                                  <td>{doc.DetallesDTE?.identificacion.numeroControl}</td>
                                  <td>{doc.DetallesDTE?.identificacion.codigoGeneracion}</td>
                                  <td>{`${getFechaCA(doc.DetallesDTE?.identificacion?.fecEmi)} ${doc.DetallesDTE?.identificacion?.horEmi} `}</td>
                                  <td>${doc.DetallesDTE?.resumen?.montoTotalOperacion}</td>
                                  <td>{renderEstadoDoc(doc)}</td>
                                </tr>
                              ))
                            }
                            </tbody>
                        </table>
                      </div>
                  </div>
                </div>
              )
            }
            <div className="dte-section">
              <div className="dte-subsection">
                  <label className="dte-subsection-title">Resumen</label>
                  <div className="tab-plane" style={{marginTop: '8px'}}>
                    {
                      (identificacion.tipoDte === "07") ? 
                      (
                        <>
                          {/* TABLA COMPROBANTE RETENCION */}
                          <div style={{overflowX: "scroll"}}>
                            <table className="table-main-responsive responsive-table-main td-left table-pointer">
                              <thead>
                                  <tr>
                                      <td>Tipo de doc. relacionado</td>
                                      <td>N° del control DTE</td>
                                      <td>N° del doc. relacionado</td>
                                      <td>Fecha del doc.</td>
                                      <td>Monto sujeto a retención</td>
                                      <td>IVA retenido</td>
                                  </tr>
                              </thead>
                              <tbody>
                              {tableProductos.map((producto) => {
                                  return(
                                    <tr>
                                      <td>{producto.TipoDocName}</td>
                                      <td>{producto.numeroControl}</td>
                                      <td>{producto.numDocumento}</td>
                                      <td>{getFechaCA(producto.fechaEmision)}</td>
                                      <td>{formatearNum(producto.montoSujetoGrav)}</td>
                                      <td>{formatearNum(producto.ivaRetenido)}</td>
                                    </tr>
                                  )})}
                                </tbody>
                            </table>
                          </div>
                          <Pagination data = {productos} state = {(items: Array<any>) => setTableProductos(items)} items = {10}/>
                        </>
                      )
                      :
                      (
                        <>
                          {/* TABLA GENERAL */}
                          <div style={{overflowX: "scroll"}}>
                            <table className="table-main-responsive responsive-table-main td-left table-pointer">
                              <thead>
                                  <tr>
                                      <td>Cantidad</td>
                                      <td>Unidad de medida</td>
                                      <td>Tipo</td>
                                      <td>Descripción</td>
                                      <td>Precio unitario</td>
                                      <td>Descuento</td>
                                      <td>Ventas gravadas</td>
                                      <td>Ventas exentas</td>
                                  </tr>
                              </thead>
                              <tbody>
                              {tableProductos.map((producto) => {
                                  let precioUnitario = 0
                                  let gravadas = 0
                                  let exentas = 0
                                  
                                  precioUnitario = parseFloat(producto.precioUni)
                                  gravadas = (precioUnitario * parseFloat(producto.cantidad)) - producto.montoDescu
                                  exentas = (precioUnitario * parseFloat(producto.cantidad)) - producto.montoDescu  

                                  return(
                                    <tr>
                                      <td>{producto.cantidad}</td>
                                      <td>{producto.descUnidad ? producto.descUnidad : (unidadesMedida.find((uni) => uni.codigo === `${producto.uniMedida}`)?.valor ?? '--')}</td>
                                      <td>{`${producto.TipoProducto === "0" ? 'Servicio' : 'Producto'} ${producto.TipoMonto === "1" ? ' exento' : ''}`}</td>
                                      <td>{producto.descripcion}</td>
                                      <td>{formatearNum(producto.precioUni)}</td>
                                      <td>{isNaN(producto.montoDescu) ? '$0.00' : formatearNum(producto.montoDescu) ?? '$0.00'}</td>
                                      <td>{producto.TipoMonto === "0" ? (isNaN(gravadas) ? '$0.00' : formatearNum(gravadas)): '$0.00'}</td>
                                      <td>{producto.TipoMonto === "1" ? (isNaN(exentas) ? '$0.00' : formatearNum(exentas)): '$0.00'}</td>
                                    </tr>
                                  )})}
                                </tbody>
                            </table>
                          </div>
                          <Pagination data = {productos} state = {(items: Array<any>) => setTableProductos(items)} items = {10}/>
                        </>
                      )
                    }
                      
                        <div className="cf-calculos-producto">
                            <table>
                                {
                                  (identificacion.tipoDte === "01") && 
                                  (<TotalesCF resumen={resumen} />)
                                }

                                {
                                  (identificacion.tipoDte === "03" || identificacion.tipoDte === "05" || identificacion.tipoDte === "06") && 
                                  (<TotalesCFF resumen={resumen} />)
                                }

                                {
                                  (identificacion.tipoDte === "04") && 
                                  (<TotalesNotaRemision resumen={resumen} />)
                                }

                                {
                                  (identificacion.tipoDte === "07") && 
                                  (<TotalesComprobanteRetencion resumen={resumen} />)
                                }

                                {
                                  (identificacion.tipoDte === "11") && 
                                  (<TotalesExportacion resumen={resumen} />)
                                }

                                {
                                  (identificacion.tipoDte === "14") && 
                                  (<TotalesSujeto resumen={resumen} />)
                                }
                            </table>
                        </div>
                  </div>
              </div>
            </div>
            <div className="dte-section">
              <div className="dte-subsection">
                <div className='dt-card-grid-3c'>
                  <div>
                    {
                      qrCode && 
                      (
                        <img
                          src={generateQRImageFromBits(qrCode ? qrCode.replace("data:image/jpeg;base64,", "") : "")}
                          alt='qr'
                          className='dt-img-qr'
                        />
                      )
                    }
                  </div>
                  <div className='dt-card-2c-responsive'>
                    <div className='detail'>
                      <label>Nombre de Entrega</label>
                      <label>{datosEmisor?.nombre}</label>
                    </div>
                    <div className='detail'>
                      <label>Nombre Recibe</label>
                      <label>{datosReceptor?.nombre || clienteReceptor?.nombre || "--"}</label>
                    </div>
                  </div>
                  <div className='dt-card-2c-responsive'>
                    <div className='detail'>
                      <label>Documento Entrega</label>
                      <label>{datosEmisor?.nit}</label>
                    </div>
                    <div className='detail'>
                      <label>Documento Recibe</label>
                      <label>{datosReceptor?.numId || documentoReceptor.numDoc || "--"}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='form-separator'></div>
        <div className='w-layout-hflex button-actions'>
          <button className='m button transparent w-inline-block' onClick={props.closeModal}>
            <div>Cerrar</div>
          </button>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalViewRelacionado